import { Injectable } from '@angular/core';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption } from 'gung-list';
import { Observable, filter } from 'rxjs';
import { OttoOwnCrossReference } from '../models/otto-olsen-cross-reference';
import { OttoOlsenCrossReferenceAdminService } from './otto-olsen-cross-reference-admin.service';
import { OttoOlsenCrossReferenceItemComponent } from '../components/otto-olsen-cross-reference-item/otto-olsen-cross-reference-item.component';

@Injectable({
  providedIn: 'root'
})
export class OttoOlsenCrossReferenceListConfigService implements ConfigService<OttoOwnCrossReference> {
  constructor(protected adminService: OttoOlsenCrossReferenceAdminService) {}

  getItems(): Observable<OttoOwnCrossReference[]> {
    // The admin service re-emits this subject after every save/delete/applied import,
    // which is what keeps the list current (same pattern as UsersService/users-list-config).
    return this.adminService.getCrossReferencesSubject().pipe(filter(list => !!list));
  }

  getFilters(): ConfigBaseFilter<OttoOwnCrossReference>[] {
    return [];
  }

  getSortOptions(): ListSortOption<OttoOwnCrossReference>[] {
    return [];
  }

  getBatchSizes(): number[] {
    return [50];
  }

  getLayouts(): ListLayout<OttoOwnCrossReference>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => OttoOlsenCrossReferenceItemComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'CrossReferenceList'
      }
    ];
  }

  getSearchTerms(item: OttoOwnCrossReference): string[] {
    return [item.crossReference, item.ottoProductId, item.crossBrand || '', item.note || ''];
  }

  getItemId(item: OttoOwnCrossReference): string {
    return item.id || `${item.crossReference}|${item.ottoProductId}`;
  }
}
